export default "__VITE_ASSET__ha4dx0Z___"